import React, {Component} from 'react';
import {CircularProgress} from '@mui/material';
import {connect} from 'react-redux';

import {getMyTransactions, BILLING_EVENT_STATUSES} from '../../actions/billing';
import Table from '../../components/Table';
import {convertToLocale, dateFormat} from '../../lib/utils';

// Map wallet_name to display label: "sms_transactional" → "Transactional"
const walletLabel = (name) => {
  if (!name) return '-';
  const parts = name.split('_');
  if (parts.length >= 2) {
    return parts.slice(1).map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ');
  }
  return name;
};

// Operation label is the balance direction: inbound = CREDITED, outbound = DEBITED.
// (transaction_status — purchased/granted/voided — is still in the row for the
// filter, but is not shown; owner decision 2026-09-13.)
const operationLabel = (type) => {
  if (type === 'inbound') return 'CREDITED';
  if (type === 'outbound') return 'DEBITED';
  return type || '-';
};

// Balance columns: numeric string from the API, or '-' for rows written
// before billing started stamping balances (migration 168).
const balanceCell = (val) => (val === undefined || val === null || val === '') ? '-' : convertToLocale(Number(val) || 0);

// Parse proto timestamp or ISO string
const formatDate = (val) => {
  if (!val) return '-';
  const d = val.seconds ? new Date(val.seconds * 1000) : new Date(val);
  return isNaN(d.getTime()) ? val : dateFormat(d.toISOString());
};

class CreditHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    // All billing events (top-ups, grants, refunds, voids, migrated + legacy),
    // no per-window SMS-usage debits — those are on SMS Reports.
    this.props.getMyTransactions('', '', 1, 100, BILLING_EVENT_STATUSES);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.transactionsResponse !== this.props.transactionsResponse) {
      this.setState({loading: false});
    }
  }

  render() {
    const {transactionsResponse} = this.props;
    const {loading} = this.state;
    const isMobile = window.isMobile();

    const transactions = transactionsResponse?.transactions || [];
    const hasData = transactions.length > 0;

    return (
      <div className='sms-parent-container' style={isMobile ? {padding: 8} : {}}>
        {loading ? (
          <CircularProgress size={80} thickness={5} />
        ) : hasData ? (
          <Table
            column={[
              {name: 'Date & Time', value: 'createdAt', cell: formatDate},
              {name: 'Operation', value: 'transactionType', cell: operationLabel},
              {name: 'SMS Type', value: 'walletName', cell: walletLabel},
              {name: 'Credits', value: 'creditAmount', cell: (val) => convertToLocale(Number(val) || 0)},
              {name: 'Previous Balance', value: 'previousBalance', cell: balanceCell},
              {name: 'Current Balance', value: 'currentBalance', cell: balanceCell},
              {name: 'Status', value: 'status'},
              {name: 'Remarks', value: 'remarks', cell: (val, row) => val || row.name || '-'},
            ]}
            data={transactions}
            showPagination
            serialNumber
            defaultPageSize={100}
          />
        ) : (
          <p style={{padding: 50, fontSize: 16, color: '#333'}}>No Credit History found!</p>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    transactionsResponse: state.billing.myTransactions,
  };
}

export default connect(mapStateToProps, {getMyTransactions})(CreditHistory);
